<template>
    <div class="list-take-order-page">
        <div class="page-wrap">

            <div class="page-title">
                <span class="text1">生产商</span> 
                <i class="el-icon-arrow-right arrow-right"></i>
                <span class="text1">生产加工</span> 
                <i class="el-icon-arrow-right arrow-right"></i>
                <span class="text2">优先推送订单列表</span> 
            </div>

            <div class="table-wrap">
                <el-table :data="tableData" style="width: 100%" v-loading="loading">
                    <el-table-column label="订单信息" width="360">
                        <template slot-scope="scope">
                            <div class="single-order-info">
                                <img class="order-img" :src="scope.row.image_file" alt=""
                                    @click="handleImgPreview(scope.row.image_file)"
                                >
                                <div class="right-box">
                                    <div class="name-line" :title="scope.row.order_name">
                                        {{scope.row.order_name}}
                                    </div>
                                    <div class="time-line">
                                        预计交货数量 {{scope.row.order_quantity}}件
                                    </div>
                                    <div class="time-line">
                                        预计交货日期 {{scope.row.order_delivery_time}}
                                    </div>
                                </div>
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column label="单价" width="150">
                        <template slot-scope="scope">
                            <span class="price-text"> ¥{{scope.row.order_unit_price}}</span>
                        </template>
                    </el-table-column>
                    
                    <el-table-column label="订单类型" width="190">
                        <template slot-scope="scope">
                            <span :class="{yellowTag:scope.row.order_type=='cmt', blueTag:scope.row.order_type=='oem'}">
                                {{scope.row.order_type|turnValToText("order_type")}}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="发单企业所在地" width="230">
                        <template slot-scope="scope">
                            <span>
                                {{scope.row.company_city}}
                            </span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="发单企业">
                        <template slot-scope="scope">
                            <span></span>
                        </template>
                    </el-table-column> -->
                    <!-- <el-table-column prop="order_type" label="交货日期">
                        <template slot-scope="scope">
                            <span>
                                {{scope.row.order_delivery_time}}
                            </span>
                        </template>
                    </el-table-column> -->
                    
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <div class="btn-line"><el-button type="primary" size="mini" @click="toDetail(scope.row)">意向接单</el-button></div>
                            <div><el-button  size="mini" plain @click="toDetail(scope.row)">查看详情</el-button></div>
                        </template>
                    </el-table-column>
                    
                    <div class="no-content" slot="empty">
                        <i class="ic-empty"></i> 
                        <span class="text">暂无数据</span>
                    </div>
                    
                </el-table>
            </div>
            <div class="pagination-wrap">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[5, 10, 20, 100]"
                    :page-size="showCount"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                >
                </el-pagination>
            </div>
        </div>
        <el-dialog :visible.sync="dialogImgVisible">
            <img width="100%" :src="dialogImgUrl" alt="">
        </el-dialog>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import api from '@/api/index.js'
    import request from '@/utils/request'
    export default {
        data() {
            return {
                loading: false,

                // 预览图片
                dialogImgUrl: '',
                dialogImgVisible: false,

                tableData: [], // 列表数据

                // 分页
                currentPage: 1,
                showCount: 10,
                total: 0,
            }
        },
        watch: {
            '$route': {
                handler: function(route) {
                    this.showCount = Number(this.$route.query.size) ? Number(this.$route.query.size) : 10
                    this.currentPage = Number(this.$route.query.page) ? Number(this.$route.query.page) : 1
                    this.getTableData();
                },
                immediate: true
            }
        },
        computed: {
            ...mapGetters([
                'userId'
            ])
        },
        methods: {
            // 图片预览
            handleImgPreview(url) {
                this.dialogImgUrl = url;
                this.dialogImgVisible = true;
            },

            toDetail(list) {
                this.$router.push({
                    path: '/detail-take-order',
                    query: {
                        orderNumber: list.order_number,
                        orderType: list.order_type,
                        brandUserId: list.order_submit_user_id
                    }
                })
            },
            handleSizeChange(val) {
                this.showCount = val
                this.currentPage = 1
                this.curRoutePush()
            },
            handleCurrentChange(val) {
                this.currentPage = val
                this.curRoutePush()
            },
            curRoutePush() {
                this.$router.push('/list-push-me'+
                    '?page=' + this.currentPage + 
                    '&size=' + this.showCount
                ).catch(err => {
                    console.log(err)
                })
            },
            getTableData() {
                let arg = {
                    userId: this.userId,
                    currentResult: this.currentPage, //起始查询条数
                    showCount: this.showCount        //相当于pageSize
                }
                this.loading = true
                this.tableData = []
                request({
                    url: api.priorityPushOrderListByCount,
                    data: arg
                }).then(res => {
                    this.loading = false
                    if (res.errorCode==200) {
                        this.total = res.data.totalCount
                        this.tableData = res.data.priorityPushOrderList.map(item => {
                            return {
                                ...item,
                                image_file: item.image_file ? api.imgPrev + item.image_file : '' 
                            }
                        })
                        
                    } else {
                        this.tableData = []
                    }
                }).catch(err => {
                    this.loading = false
                    console.log(err)
                })
            }

        }
    }
</script>

<style scoped="scoped" lang="scss">
    .list-take-order-page {
        .page-wrap {
            width: 1184px;
            margin: 0 auto;
        }
        .page-title {
            padding: 24px 0;
            .arrow-right {
                font-size: 12px;
                color: rgba(0, 0, 0, 0.65);
                margin: 0 8px;
            }
            .text1 {
                font-size: 14px;
                line-height: 22px;      
                color: rgba(0, 0, 0, 0.45);
            }
            .text2 {
                font-size: 14px;
                line-height: 22px;      
                color: rgba(0, 0, 0, 0.65);
            }
        }
        .table-wrap {
            background: #fff;
            padding: 24px 24px 0;
            .single-order-info {
                display: flex;
                .order-img {
                    background: #f0f0f0;
                    width: 64px; height: 64px;
                    margin-right: 16px; 
                    vertical-align: top;
                    object-fit: cover;
                    flex: none;
                }
                .right-box {
                    .name-line {
                        font-size: 16px;
                        font-weight: 600;
                        color: rgba(0, 0, 0, 0.85);
                        line-height: 24px;
                        margin-bottom: 8px;
                        text-align: justify;
                    }
                    .time-line{
                        margin-top: 2px;
                        height: 20px;
                        font-size: 14px;
                        color: #000000;
                        line-height: 20px;
                    }
                }
            }
            .price-text {
                color: #FF4D4F;
                font-size: 20px;
            }
            .btn-line {
                margin-bottom: 10px;
            }
            
        }
        .pagination-wrap {
            padding: 23px 32px;
            text-align: right;
        }
    }
    
</style>
